// extracted by mini-css-extract-plugin
export var base = "Heading-module--base--c0ddb";
export var bold = "Heading-module--bold--75e0c";
export var center = "Heading-module--center--2be9f";
export var h1 = "Heading-module--h1--22072";
export var h1alt = "Heading-module--h1alt--24441";
export var h2 = "Heading-module--h2--0bb5c";
export var h3 = "Heading-module--h3--d6ba9";
export var h4 = "Heading-module--h4--5e631";
export var h5 = "Heading-module--h5--ee50b";
export var narrow = "Heading-module--narrow--d9862";
export var normal = "Heading-module--normal--becb4";
export var uppercase = "Heading-module--uppercase--39ce6";